import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import PlatformSuggestion from "../../../platform_feedback/platform_suggestion"

export class SearchSuggestions extends React.Component {
  onSuggestionClick = serviceName => {
    window.uiEventTracker.trackUserInteraction(
      "web.search.suggestion.clicked",
      {
        service_name: serviceName,
      }
    )
  }

  render() {
    return (
      <div className="recommended-services">
        <p>
          {`We couldn't find anything matching ${this.props.searchTerm}.`}
          <br />
          {this.props.signedIn && (
            <PlatformSuggestion suggestionType="service" displayInline={true} />
          )}
        </p>
        <h4>Try some of these:</h4>
        <ul className="recommended-services">
          {this.props.recommendedServices.map((service, index) => {
            return (
              <li key={`recommended-service-${index}`}>
                <a
                  href={`/${service.module_name}`}
                  onClick={() => this.onSuggestionClick(service.name)}
                >
                  {service.name}
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    searchTerm: state.searchResults.searchTerm,
    recommendedServices: state.searchResults.recommendedServices,
    signedIn: state.searchResults.signedIn,
  }
}

export default connect(mapStateToProps, null)(SearchSuggestions)

SearchSuggestions.propTypes = {
  searchTerm: PropTypes.string,
  recommendedServices: PropTypes.array,
  signedIn: PropTypes.bool,
}

SearchSuggestions.defaultProps = {
  recommendedServices: [],
}
